import { doc, updateDoc } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { db } from '../config/firebase';

class NotificationService {
  constructor() {
    this.messaging = null;
    this.vapidKey = 'BOO4ZLwt4_xDqyxGGkY9iVI6XbF-QY2hNc8sSJ3_kkLWSFOwpVCc86H8uwChYhx9cccU7coNTaYhK2NZnRZJHaU'; // Firebase 콘솔에서 가져온 VAPID 키
  }

  /**
   * FCM 초기화
   */
  async initialize() {
    try {
      // Service Worker 등록 확인
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );
        console.log('Service Worker registered:', registration);
      }

      // 알림 권한 요청
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        console.log('Notification permission granted');
        return true;
      } else {
        console.log('Notification permission denied');
        return false;
      }
    } catch (error) {
      console.error('Error initializing notifications:', error);
      return false;
    }
  }

  /**
   * FCM 토큰 가져오기
   */
  async getToken(userId) {
    try {
      // VAPID 키가 설정되지 않았으면 스킵
      if (!this.vapidKey || this.vapidKey === 'YOUR_VAPID_KEY') {
        console.warn('VAPID key not configured. Push notifications will not work.');
        console.warn('Please follow the setup guide: /docs/CHAT_SETUP_GUIDE.md');
        return null;
      }

      const messaging = getMessaging();
      const token = await getToken(messaging, {
        vapidKey: this.vapidKey
      });

      if (token) {
        console.log('FCM Token:', token);

        // Firestore에 토큰 저장
        await this.saveTokenToFirestore(userId, token);

        return token;
      } else {
        console.log('No registration token available');
        return null;
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
      console.error('Please check your Firebase configuration and VAPID key');
      return null;
    }
  }

  /**
   * Firestore에 토큰 저장
   */
  async saveTokenToFirestore(userId, token) {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        fcmToken: token,
        fcmTokenUpdatedAt: new Date()
      });
      console.log('FCM token saved to Firestore');
    } catch (error) {
      console.error('Error saving FCM token:', error);
    }
  }

  /**
   * 포그라운드 메시지 수신 리스너
   */
  onMessageReceived(callback) {
    try {
      const messaging = getMessaging();

      return onMessage(messaging, (payload) => {
        console.log('Foreground message received:', payload);

        // 브라우저 알림 표시
        if (Notification.permission === 'granted') {
          const notificationTitle = payload.notification?.title || '새 메시지';
          const notificationOptions = {
            body: payload.notification?.body || '',
            icon: '/logo192.png',
            badge: '/logo192.png',
            tag: 'chat-notification',
            data: payload.data
          };

          const notification = new Notification(notificationTitle, notificationOptions);

          notification.onclick = () => {
            window.focus();
            notification.close();

            // 채팅 열기
            if (callback) {
              callback(payload.data);
            }
          };
        }
      });
    } catch (error) {
      console.error('Error setting up message listener:', error);
    }
  }

  /**
   * 로컬 알림 표시 (웹 알림 대체용)
   */
  showLocalNotification(title, body, data) {
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: 'chat-notification',
        data
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    }
  }

  /**
   * 알림 권한 확인
   */
  hasPermission() {
    return 'Notification' in window && Notification.permission === 'granted';
  }

  /**
   * 알림 권한 요청
   */
  async requestPermission() {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }
}

export const notificationService = new NotificationService();
